'use client';

import { useOfflineSync } from '@/hooks/use-offline-sync';
import { Button } from '@/components/ui/button';
import { Wifi, WifiOff, Loader2, CheckCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ConnectionStatus() {
  const { isOnline, isSyncing, pendingChanges, lastSyncTime, sync } = useOfflineSync();

  return (
    <div className="fixed bottom-20 right-4 z-50 flex items-center gap-2 rounded-lg bg-background/95 p-2 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center gap-2">
        {isOnline ? (
          <Wifi className="h-4 w-4 text-green-500" />
        ) : (
          <WifiOff className="h-4 w-4 text-yellow-500" />
        )}
        <span className="text-sm font-medium">
          {isOnline ? 'Online' : 'Offline'}
        </span>
      </div>

      {pendingChanges > 0 && (
        <div className="flex items-center gap-2 border-l border-border pl-2">
          <span className="text-sm text-muted-foreground">
            {pendingChanges} alteração{pendingChanges !== 1 ? 'ões' : ''} pendente{pendingChanges !== 1 ? 's' : ''}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => sync()}
            disabled={!isOnline || isSyncing}
            className={cn(
              "h-8 px-2",
              isSyncing && "animate-pulse"
            )}
          >
            {isSyncing ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <CheckCircle className="h-4 w-4" />
            )}
            <span className="ml-2">
              {isSyncing ? 'Sincronizando...' : 'Sincronizar'}
            </span>
          </Button>
        </div>
      )}

      {lastSyncTime && !pendingChanges && (
        <div className="border-l border-border pl-2">
          <span className="text-xs text-muted-foreground">
            Última sincronização: {new Date(lastSyncTime).toLocaleTimeString()}
          </span>
        </div>
      )}
    </div>
  );
}